import { JsonObject, JsonProperty } from 'json2typescript';

import GoodsOption from '@/models/cart/GoodsOption';
import SettlementCartHistoryItemEntry from '@/models/entry/SettlementCartHistoryItemEntry';
import * as StringUtil from '@/common/StringUtil';

@JsonObject('settlement_cart_history_item')
export default class SettlementCartHistoryItem {
  constructor() {
    this.totalAmount = 0;
    this.rankCode = '';
    this.goodsCode = '';
    this.title = '';
    this.resourceUri = '';
    this.alternativeText = '';
    this.quantity = 1;
    this.goodsOptions = new Array<GoodsOption>();
    this.entries = new Array<SettlementCartHistoryItemEntry>();
  }

  @JsonProperty('total_amount')
  public totalAmount: number;

  @JsonProperty('exam_rank_code')
  public rankCode: string;

  @JsonProperty('goods_code')
  public goodsCode: string;

  @JsonProperty('title')
  public title: string;

  @JsonProperty('rank_icon_resource_uri', null, true)
  public resourceUri: string;

  @JsonProperty('rank_icon_alternative_text', null, true)
  public alternativeText: string;

  @JsonProperty('quantity')
  public quantity: number;

  @JsonProperty('entries', [SettlementCartHistoryItemEntry], true)
  public entries: SettlementCartHistoryItemEntry[];

  @JsonProperty('goods_options', [GoodsOption], true)
  public goodsOptions: GoodsOption[];

  public get isGoods(): boolean {
    if (this.rankCode === 'null') {
      return true;
    }
    return StringUtil.isEmpty(this.rankCode);
  }
}
